module.exports = __webpack_public_path__ + "static/widgets_6-903c2d2be26ef61e3e106afae155ef63.png";